export default {
    title: '매일국어 T 활동별 가이드 모아보기',
};
